import type { Instance } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeleteInstanceDialogProps {
  instance: Instance | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteInstanceDialog({ instance, isDeleting, onCancel, onConfirm }: DeleteInstanceDialogProps) {
  return (
    <Modal open={instance !== null} title="Destroy instance" onClose={onCancel}>
      <p>
        Destroy <strong>{instance?.id}</strong> ({instance?.region}, {instance?.serverType})? This deprovisions the
        server at the provider — its root disk and every volume on it are gone, and anything still deployed on it
        stops. This can't be undone.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Destroying…" : "Destroy"}
        </Button>
      </div>
    </Modal>
  );
}
